import { useMemo } from "react";

import Timestamp from "components/Timestamp";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import { Stack } from "types/generated";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import TableCellEmpty from "ds/components/Table/Row/CellEmpty";
import { makeTimestampToCopy } from "ds/components/Table/helpers";

import useCellCopyAction from "../useCellCopyAction";
import { STACKS_COLUMN_ID } from "../constants";

const StacksTableLastApplyAttemptCell = ({
  item: stack,
  ...cellProps
}: TableSimpleCellProps<Stack>) => {
  const copyAction = useCellCopyAction({
    column: STACKS_COLUMN_ID.LAST_APPLY_ATTEMPT,
    text: makeTimestampToCopy(stack.lastApplyAt || 0),
  });

  const isEmpty = !stack.lastApplyAt;
  const actions = useMemo(() => (isEmpty ? undefined : [copyAction]), [isEmpty, copyAction]);

  return (
    <TableSimpleCell {...cellProps} actions={actions}>
      {isEmpty && <TableCellEmpty />}

      {stack.lastApplyAt && <Timestamp timestamp={stack.lastApplyAt} />}
    </TableSimpleCell>
  );
};

export default StacksTableLastApplyAttemptCell;
